import { Map } from 'immutable';
import get from 'lodash/get';
import omit from 'lodash/omit';

import {
  ANSWERS__POST,
  RESULT__INIT,
  RESULT__FETCH,
  RESULT__FINALISE,
  RESULT__REDIRECTING,
  RESULT__SET_CURRENT_PAGE_ID,
} from '../constants';
import { getBeginType, getErrorType } from '../selectors';
import { bugsnagSetUser, patch } from '../../util';
import { getQualificationRejectionData } from './util.result';

const defaultState = new Map();

function mergeResult(state, { data, type }) {
  const {
    primary_email: primaryEmail,
    campaign_email: campaignEmail,
    display_name: firstName,
    id,
  } = get(data, 'result.participant', {});

  const email = primaryEmail || campaignEmail;

  if (id && email && firstName) {
    const bugsnagData = { email, id, firstName };
    bugsnagSetUser(bugsnagData);
  }

  const omitKeys = ['answers', 'participant'];

  if (type === ANSWERS__POST) {
    omitKeys.push('authentication_attempts');
  }

  return patch(
    state,
    omit({ ...data.result, currentPageIdFixed: data.result.current_page_id }, omitKeys),
  );
}

export default function (state = defaultState, action) {
  switch (action.type) {
    case ANSWERS__POST:
    case RESULT__INIT:
    case RESULT__FETCH:
      return mergeResult(state, action);
    case getErrorType(RESULT__INIT): {
      const rejection = getQualificationRejectionData(action.error);
      if (!rejection) return state;
      return patch(state, {
        state: 'disqualified',
        disqualification: rejection,
        displayOrder: [],
      });
    }
    case RESULT__FINALISE:
      return patch(state, { state: 'finished' });
    case getBeginType(RESULT__REDIRECTING):
      return patch(state, { state: 'redirect_begin' });
    case getErrorType(RESULT__REDIRECTING):
      return patch(state, { state: 'redirect_error' });
    case RESULT__REDIRECTING:
      return patch(state, { state: 'redirected' });
    case RESULT__SET_CURRENT_PAGE_ID:
      return patch(state, { currentPageId: action.data.currentPageId });
    default:
      return state;
  }
}

export const select = (state) => state.model.toJS();

/**
 * @see docs/worklog/maintenance/20093-investigate-facebook-auth-errors/rfc-frontend.md
 */
